import { ref } from 'vue'

const isModalVisible = ref(false)
const preselectedPerimeterId = ref<number | null>(null)

const usePerimeterChangeConfirmationModal = () => {
  const toggleModal = (selectedPerimeterId?: number | null) => {
    isModalVisible.value = !isModalVisible.value
    if (isModalVisible.value) {
      preselectedPerimeterId.value = selectedPerimeterId ?? null
    }
  }

  return { toggleModal, isModalVisible, preselectedPerimeterId }
}

export default usePerimeterChangeConfirmationModal
